<tbody>
    <tr class="tablebox" *ngFor="let tran of transactionList; let i = index" [attr.data-index]="i">
        <td>
            <div class="transaction-row">
                <div class="transaction-row-element-1">
                    <div class="transaction-type">
                        {{ tran.type | humanize }}

                        <div
                            class="transaction-group-id"
                            *ngIf="tran.groupId"
                            [style.background-color]="groupIdColours[tran.groupId]">
                            {{ tran.groupId }}
                        </div>
                    </div>

                    <div class="transaction-status" *ngIf="tran.status === status.success">
                        <img class="transaction-status-icon" src="assets/images/green-small.png" />
                        {{ tran.status | uppercase | humanize }}
                    </div>

                    <div class="transaction-status" *ngIf="tran.status === status.pending">
                        <img class="transaction-status-icon" src="assets/images/yellow-small.png" />
                        {{ tran.status | uppercase | humanize }}
                    </div>

                    <div class="transaction-status" *ngIf="tran.status === 'payment pending'">
                        <img class="transaction-status-icon" src="assets/images/yellow-small.png" />
                        {{ tran.status | uppercase | humanize }}
                    </div>

                    <div class="transaction-status" *ngIf="tran.status === status.failed">
                        <img class="transaction-status-icon" src="assets/images/red-small.png" />
                        {{ tran.status | uppercase | humanize }}
                    </div>

                    <div class="transaction-status" *ngIf="tran.status === status.onhold">
                        <img class="transaction-status-icon" src="assets/images/blue-small.png" />
                        {{ tran.status | uppercase | humanize }}
                    </div>

                    <div class="transaction-status" *ngIf="tran.status === status.processing">
                        <img class="transaction-status-icon" src="assets/images/yellow-small.png" />
                        {{ tran.status | uppercase | humanize }}
                    </div>

                    <div class="transaction-status" *ngIf="tran.status === status.cancelled">
                        <img class="transaction-status-icon" src="assets/images/red-small.png" />
                        {{ tran.status | uppercase | humanize }}
                    </div>
                </div>

                <div class="transaction-row-element-2">
                    <div class="transaction-user-name">
                        <a (click)="commonUtil.goToSenderProfile(tran)">
                            <strong>
                                <u>{{ tran.fromUserName }}</u>
                            </strong>
                        </a>
                    </div>

                    <img src="assets/images/right-arrow.png" />

                    <div class="transaction-user-name">
                        <a (click)="commonUtil.goToReceiverProfile(tran)">
                            <strong>
                                <u>{{ tran.getToUserName() }}</u>
                            </strong>
                        </a>
                    </div>
                </div>

                <div class="transaction-row-element-3">
                    <div class="transaction-amount" *ngIf="tran.received" style="color: #5bc79c">
                        {{ tran.amount }}
                    </div>

                    <div class="transaction-amount" *ngIf="!tran.received">
                        {{ tran.amount }}
                    </div>

                    <div class="transaction-date">
                        {{ tran.date | date: 'dd/MM/yyyy, h:mm a' }}
                    </div>
                </div>

                <div class="transaction-row-element-4">
                    <img
                        src="assets/images/default-transaction-detail.png"
                        id="{{ 'logo-' + i }}"
                        (click)="showDetails('details-' + i, 'logo-' + i)" />
                </div>
            </div>

            <div class="transaction-details" id="{{ 'details-' + i }}">
                <section class="transaction-details-section">
                    <div class="row mb-2">
                        <div class="col-md-12 header">Overview</div>
                    </div>

                    <div class="row">
                        <div class="col-md-6">
                            <div class="row">
                                <div class="col-md-6">
                                    <label>WHOLESALER</label>

                                    <div class="label-value">
                                        {{ tran.wholesaler | humanize }}
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <label>CASHBACKS</label>

                                    <div class="label-value">
                                        @if (tran?.cashback?.amount > 0) {
                                            @if (tran.getCashbackBlockchainUrl()) {
                                                <a
                                                    [href]="tran.getCashbackBlockchainUrl()"
                                                    target="_blank"
                                                    class="cashback-amount-link">
                                                    {{ tran.getCashbackAmount() | number: '1.2-2' }}
                                                </a>
                                            } @else {
                                                <span
                                                    class="cashback-amount-link cashback-amount-no-link">
                                                    {{ tran.getCashbackAmount() | number: '1.2-2' }}
                                                </span>
                                            }
                                        } @else {
                                            0.00
                                        }
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <label>
                                        {{ companyService.getSelectedCompanyName() | uppercase }}
                                        TRANS ID
                                    </label>

                                    <div class="label-value">
                                        {{ tran.transactionCode }}

                                        <div>
                                            <a (click)="copyText(tran.transactionCode)">
                                                <img src="assets/images/copy-icon.png" />
                                                copy
                                            </a>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-6" *ngIf="tran.isPackageCollection()">
                                    <label>PACKAGE COLLECTION STATUS</label>

                                    <div
                                        class="label-value"
                                        *ngIf="tran?.packageCollection?.status === 'Collected'">
                                        <img
                                            class="transaction-status-icon"
                                            src="assets/images/green-small.png" />

                                        {{ tran?.getPackageCollectionStatus() | humanize }}
                                    </div>

                                    <div
                                        class="label-value"
                                        *ngIf="tran?.packageCollection?.status === 'Not Collected'">
                                        <img
                                            class="transaction-status-icon"
                                            src="assets/images/yellow-small.png" />

                                        {{ tran?.getPackageCollectionStatus() | humanize }}
                                    </div>
                                </div>

                                <div class="col-md-6" *ngIf="tran.shopifyOrder?.isCashOnDelivery">
                                    <label>Tele Agent</label>

                                    <div class="label-value">
                                        {{ tran.shopifyOrder?.agent?.name }}
                                    </div>
                                </div>
                            </div>

                            @if (transactionType.marketplace_buy === tran.type) {
                                <div class="row">
                                    <div class="col-md-6">
                                        <label>ORDER REFERRED BY</label>

                                        <div class="label-value">
                                            {{ tran?.shopifyOrder?.referredBy }}
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <label>ORDER REFERRED BY CODE</label>

                                        <div class="label-value">
                                            {{ tran?.shopifyOrder?.referralCode | uppercase }}
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>

                        <div class="col-md-6">
                            <div class="row">
                                <div class="col-md-6">
                                    <label>SENDER FEE</label>

                                    <div class="label-value">
                                        {{ tran.senderFee }}
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <label>RECEIVER FEE</label>

                                    <div class="label-value">
                                        {{ tran.receiverFee }}
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <label>BLOCKCHAIN TRANSFER TRANSACTION</label>

                                    @if (tran.transferTransactionId) {
                                        <div class="label-value">
                                            <a
                                                href="{{ tran.transferTransactionId }}"
                                                target="_blank">
                                                <u>VIEW ON BLOCKCHAIN</u>
                                            </a>
                                        </div>
                                    }
                                </div>
                            </div>

                            @if (tran.status === status.failed) {
                                <div class="row">
                                    <div class="col-md-12">
                                        <label>FAILURE MESSAGE</label>

                                        <div id="trans-failure-message" class="label-value">
                                            {{ tran.description }}
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>

                    <!-- CASHBACK ALLOCATIONS -->
                    <div class="row mt-3">
                        <div class="col-md-12">
                            <hr class="cashback-divider" />
                        </div>
                    </div>

                    <!--
                        LP-5358 / LP-5360: the earn-allocation table now lives in a shared
                        component, so the admin and Enterprise views render one implementation.
                        The markup moved verbatim; the responsive layout and the column-overlap
                        fix live in the shared stylesheet.
                    -->
                    @if (tran.hasCashbackAllocations()) {
                        <div class="row cashback-allocation-section">
                            <div class="col-md-12">
                                <app-cashback-allocation-table
                                    [rows]="tran.getAllocationBalanceRows()" />
                            </div>
                        </div>
                    }

                    <!--
                        LP-5360: redemption legs now render through a shared component too, so
                        the admin and Enterprise views cannot drift. The inline version had
                        already drifted once -- it carried no data-labels, so its rows would have
                        been unlabelled cards on mobile.
                    -->
                    @if (tran.hasRedemptionSupplierLegs()) {
                        <div class="row cashback-allocation-section">
                            <div class="col-md-12">
                                <app-cashback-redemption-table
                                    [rows]="tran.getRedemptionLegRows()" />
                            </div>
                        </div>
                    }

                    <!-- SENDER / RECEIVER -->
                    <div class="row mt-4">
                        <div class="col-md-6">
                            <div class="row">
                                <div class="col-md-12 header">Sender Information</div>
                            </div>

                            <div class="row">
                                <div class="col-md-4">
                                    <label>USER NAME</label>

                                    <div class="label-value">
                                        {{ tran.fromUserName }}
                                    </div>
                                </div>

                                <div class="col-md-4">
                                    <label>MOBILE NUMBER</label>

                                    <div class="label-value">
                                        {{ tran.fromMobileNumber }}
                                    </div>
                                </div>

                                <div class="col-md-4">
                                    <label>ACCOUNT TYPE</label>

                                    <div class="label-value">
                                        {{ tran.fromRole | humanize }}
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <!--
                                    LP-5358: a parent-level pair is correct whenever the parent
                                    transaction is itself the financial movement, which is every
                                    legacy/wallet-level transaction and every modern one with a real
                                    wallet leg -- so this rendering is preserved by default. It is
                                    replaced by NA only where the backend explicitly states there
                                    was no parent wallet movement, because an aggregate pair would
                                    then misrepresent accounting that happened per allocation.

                                    LP-5358 (Kit Kat UAT, TC-KK-ALLOC-017): labelled MAIN WALLET
                                    because an unlabelled pair was being compared against the
                                    per-supplier cashback figures above and against
                                    wallet_balance.available_amount -- three different ledgers.
                                    These two values are authoritative main-wallet (CZAR) readings
                                    and are NOT derived from, nor comparable to, either of those.

                                    A flat or zero pair here is a truthful record, not a missing
                                    one: on an earn-only purchase no CZAR moves on the wallet leg,
                                    and the backend persists the after-value before the cashback
                                    allocations are even created (measured on DEV: after-value at
                                    01:36:03.697, first allocation at 01:36:04). The cashback credit
                                    this transaction produces lands afterwards and is recorded per
                                    supplier above. The hint below says so in the UI rather than
                                    leaving the reader to infer "nothing moved".
                                -->
                                <div class="col-md-4">
                                    <label title="Available balance in the trader&rsquo;s main wallet (CZAR), net of any pending transfer-to-bank holds. Not the per-supplier cashback balances shown above, and not the supplier&rsquo;s funding balance.">MAIN WALLET BALANCE BEFORE</label>

                                    <div class="label-value">
                                        @if (tran.isParentBalanceNotApplicable()) {
                                            <span
                                                class="parent-balance-not-applicable"
                                                title="Balance movement for this transaction is recorded per supplier allocation. See Cashback Allocations above.">
                                                NA
                                            </span>
                                        } @else if (tran.getFromUserBalanceBeforeDisplay()) {
                                            {{ tran.getFromUserBalanceBeforeDisplay() }}
                                        } @else {
                                            <span class="allocation-unavailable">
                                                {{ unavailableDisplay }}
                                            </span>
                                        }
                                    </div>
                                </div>

                                <div class="col-md-4">
                                    <label title="Available balance in the trader&rsquo;s main wallet (CZAR), net of any pending transfer-to-bank holds. Not the per-supplier cashback balances shown above, and not the supplier&rsquo;s funding balance.">MAIN WALLET BALANCE AFTER</label>

                                    <div class="label-value">
                                        @if (tran.isParentBalanceNotApplicable()) {
                                            <span
                                                class="parent-balance-not-applicable"
                                                title="Balance movement for this transaction is recorded per supplier allocation. See Cashback Allocations above.">
                                                NA
                                            </span>
                                        } @else if (tran.getFromUserBalanceAfterDisplay()) {
                                            {{ tran.getFromUserBalanceAfterDisplay() }}
                                        } @else {
                                            <span class="allocation-unavailable">
                                                {{ unavailableDisplay }}
                                            </span>
                                        }
                                    </div>
                                </div>

                                <!--
                                    LP-5358: explains a correct-but-flat main-wallet pair instead of
                                    leaving the reader to conclude nothing moved. Shown whenever the
                                    transaction's real movement was recorded per supplier. This does
                                    NOT suppress or alter the authoritative pair above -- suppressing
                                    a value the backend called authoritative would be the portal
                                    overriding the ledger.
                                -->
                                @if (tran.hasCashbackAllocations() || tran.hasRedemptionSupplierLegs()) {
                                    <!--
                                        LP-5358 (Codex PR #112, P2): says WHERE cashback movement is
                                        recorded, without asserting that any occurred. The presence
                                        of allocation rows does not prove a movement: this view
                                        deliberately supports FAILED legs with no snapshot and
                                        PENDING legs with no final value, and a transaction can hold
                                        nothing but those. The earlier wording ("the cashback that
                                        moved ... does not mean nothing moved") claimed a movement the
                                        authoritative data had not established -- the same mistake as
                                        fabricating a figure, made in prose instead of numbers.
                                    -->
                                    <div class="col-md-12 ledger-scope-hint">
                                        The main wallet values above cover this transaction&rsquo;s
                                        own wallet leg only. Any cashback movement for this
                                        transaction is recorded per supplier
                                        @if (tran.hasRedemptionSupplierLegs()) {
                                            under Cashback Redemption
                                        } @else {
                                            under Cashback Allocations
                                        }
                                        and settles separately, so these values alone do not show
                                        the whole picture.
                                    </div>
                                }

                                <div class="col-md-4">
                                    <label>USER CODE</label>

                                    <div class="label-value">
                                        {{ tran.fromUserCode }}
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-4">
                                    <label>WALLET ID</label>

                                    <div class="label-value">
                                        {{ tran.fromWalletId || 'NA' }}

                                        <div>
                                            <a (click)="copyText(tran.fromWalletId)">
                                                <img src="assets/images/copy-icon.png" />
                                                copy
                                            </a>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-4">
                                    <label>USER REFERRED BY</label>

                                    <div class="label-value">
                                        {{ tran.senderReferredBy }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="row">
                                <div class="col-md-12 header">Receiver Information</div>
                            </div>

                            <div class="row">
                                <div class="col-md-4">
                                    <label>USER NAME</label>

                                    <div class="label-value">
                                        {{ tran.toUserName }}
                                    </div>
                                </div>

                                <div class="col-md-4">
                                    <label>MOBILE NUMBER</label>

                                    <div class="label-value">
                                        {{ tran.toMobileNumber }}
                                    </div>
                                </div>

                                <div class="col-md-4">
                                    <label>ACCOUNT TYPE</label>

                                    <div class="label-value">
                                        {{ tran.toRole | humanize }}
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-4">
                                    <label title="Available balance in the trader&rsquo;s main wallet (CZAR), net of any pending transfer-to-bank holds. Not the per-supplier cashback balances shown above, and not the supplier&rsquo;s funding balance.">MAIN WALLET BALANCE BEFORE</label>

                                    <div class="label-value">
                                        @if (tran.isParentBalanceNotApplicable()) {
                                            <span
                                                class="parent-balance-not-applicable"
                                                title="Balance movement for this transaction is recorded per supplier allocation. See Cashback Allocations above.">
                                                NA
                                            </span>
                                        } @else if (tran.getToUserBalanceBeforeDisplay()) {
                                            {{ tran.getToUserBalanceBeforeDisplay() }}
                                        } @else {
                                            <span class="allocation-unavailable">
                                                {{ unavailableDisplay }}
                                            </span>
                                        }
                                    </div>
                                </div>

                                <div class="col-md-4">
                                    <label title="Available balance in the trader&rsquo;s main wallet (CZAR), net of any pending transfer-to-bank holds. Not the per-supplier cashback balances shown above, and not the supplier&rsquo;s funding balance.">MAIN WALLET BALANCE AFTER</label>

                                    <div class="label-value">
                                        @if (tran.isParentBalanceNotApplicable()) {
                                            <span
                                                class="parent-balance-not-applicable"
                                                title="Balance movement for this transaction is recorded per supplier allocation. See Cashback Allocations above.">
                                                NA
                                            </span>
                                        } @else if (tran.getToUserBalanceAfterDisplay()) {
                                            {{ tran.getToUserBalanceAfterDisplay() }}
                                        } @else {
                                            <span class="allocation-unavailable">
                                                {{ unavailableDisplay }}
                                            </span>
                                        }
                                    </div>
                                </div>

                                <div class="col-md-4">
                                    <label>USER CODE</label>

                                    <div class="label-value">
                                        {{ tran.toUserCode }}
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-4">
                                    <label>WALLET ID</label>

                                    <div class="label-value">
                                        {{ tran.toWalletId || 'NA' }}

                                        <div>
                                            <a (click)="copyText(tran.toWalletId)">
                                                <img src="assets/images/copy-icon.png" />
                                                copy
                                            </a>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-4">
                                    <label>USER REFERRED BY</label>

                                    <div class="label-value">
                                        {{ tran.receiverReferredBy }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </td>
    </tr>
</tbody>
